import { user_response, UserTypes } from '../User';

export interface answer_history_response {
    id: number;
    answer_id: number;
    value: string;
    created_at?: string;
    updated_at?: string;
    updated_by?: user_response;
}

export class AnswerHistory {
    public id: number = 0;
    public answerId: number = 0;
    public value: any;
    public createdAt: Date = new Date();
    public updatedAt: Date = new Date();
    public updatedBy: null | user_response = {
        id: 0,
        name: '',
        lname: '',
        email: '',
        type: UserTypes.Admin,
        phone: '',
    };
    public map(data: answer_history_response) {
        this.id = data.id;
        this.answerId = data.answer_id;
        this.value = JSON.parse(data.value);
        this.createdAt = new Date(data?.created_at ?? '');
        this.updatedAt = new Date(data?.updated_at ?? '');
        this.updatedBy = data?.updated_by ?? this.updatedBy;
        return this;
    }

    public responsify(): answer_history_response {
        return {
            id: this.id,
            answer_id: this.answerId,
            value: JSON.stringify(this.value),
        };
    }

    public static create(data: answer_history_response) {
        let r = new this();
        return r.map(data);
    }
}
